import { useQuery } from '@tanstack/react-query';
import { fetchInventory } from '../api/inventory';

interface UseInventoryOptions {
  search?: string;
  category?: string;
}

export function useInventory(options: UseInventoryOptions = {}) {
  return useQuery({
    queryKey: ['inventory', options],
    queryFn: () => fetchInventory(options),
  });
}